import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function ForexBrokerageLicenseWesternSahara (){

    return (
        <main className='main'>

            <IntroSection
                title="Forex & Brokerage License in Western Sahara"
                subtitle="Launch Your Brokerage with CRA Licensing"
                description =
                    "
                        The <b>Capital Regulatory Authority (CRA)</b> of <b>Western Sahara</b> provides a <b>flexible framework</b> for obtaining <b>Forex and Brokerage Licenses</b>, ideal for <b>startups</b>, <b>prop trading firms</b>, and <b>established brokerages</b> seeking a <b>fast, cost-effective offshore jurisdiction</b>.
                        <br/>
                        With a <b>Western Sahara license</b>, you can legally offer <b>forex</b>, <b>CFD trading</b>, and <b>brokerage services</b> to <b>international clients</b>, while benefiting from <b>efficient regulations</b> and <b>lower capital requirements</b> compared to <b>EU/Tier-1 regulators</b>.
                    "
                badges={
                    [
                        "Forex Broker License",
                        "CFD License",
                        "Investment Dealer License"
                    ]
                }
                buttonText="Request a Brokerage License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/forex-brokerage-license-western-sahara-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Western Sahara?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Fast Approvals", text: "quicker licensing than EU or UK regulators" },
                                        { title: "Cost-Effective Setup", text: "affordable compared to Cyprus, Malta, FCA" },
                                        { title: "Global Reach", text: "operate internationally under CRA license" },
                                        { title: "Crypto & Fintech Friendly", text: "hybrid brokerage models supported" },
                                        { title: "Flexible Structures", text: "STP, ECN, Market Maker, Prop Trading" }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What Brokerage Licenses Cover"
                        subtitle='With a CRA license in Western Sahara, your company may operate:'
                        item={
                            [
                                { title: "Forex Brokerage", text: "STP, ECN, and Market Maker operating models" },
                                { title: "CFD Trading", text: "indices, commodities, cryptocurrencies, and stock derivatives" },
                                { title: "Investment Dealer Services", text: "portfolio management and financial advisory operations" },
                                { title: "Prop Trading Structures", text: "funded trader program setups" },
                                { title: "Hybrid Forex + Crypto Models", text: "combined brokerage and digital asset trading solutions" }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Licensing Classes"
                        blocks={[
                            {
                                title: "Class A — Full Forex & Brokerage License",
                                items:
                                    [
                                        {
                                            title: "Regulatory Authority",
                                            text: "Authorizes the provision of forex, CFD, and investment dealer services."
                                        },
                                        {
                                            title: "Platform & Liquidity Access",
                                            text: "Enables integration with MT4/MT5 platforms and access to major liquidity providers."
                                        },
                                        {title: "Benefits"},
                                        {
                                            title: "Global Operations",
                                            text: "Operate internationally as a fully licensed forex and CFD brokerage."
                                        },
                                        {
                                            title: "Financial Infrastructure Access",
                                            text: "Gain access to PSPs, banking solutions, and top-tier liquidity providers."
                                        },
                                        {
                                            title: "Enhanced Client Trust",
                                            text: "Build credibility with traders by operating under a recognized offshore license."
                                        },
                                    ]

                            },
                            {
                                title: "Class B — Restricted Brokerage License",
                                items:
                                    [
                                        {
                                            title: "Designed for Prop Firms & Small Brokerages",
                                            text: "Purpose-built for funded trader programs and emerging brokerages seeking a simplified regulatory path."
                                        },
                                        {
                                            title: "Restricted Client Base",
                                            text: "Allows the provision of trading services to a limited number of clients approved by the CRA."
                                        },
                                        {title: "Benefits"},
                                        {
                                            title: "Lower Capital Requirements",
                                            text: "Launch operations with significantly reduced initial funding compared to major regulatory jurisdictions."
                                        },
                                        {
                                            title: "Focused Client Engagement",
                                            text: "Ideal for prop trading firms or niche-market brokerages seeking flexible operating models."
                                        },
                                        {
                                            title: "Credible Oversight",
                                            text: "CRA regulatory supervision provides legitimacy without the burdens of heavy compliance frameworks."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "1. Business Plan & Model Selection",
                                    text: "Choose operational structure: STP, ECN, Market Maker, or Prop Trading. Define target markets and product offerings."
                                },
                                {
                                    title: "2. Company Incorporation",
                                    text: "Register a legal entity in Western Sahara under the CRA regulatory framework to initiate the licensing process."
                                },
                                {
                                    title: "3. Compliance Documentation",
                                    text: "Prepare AML/KYC manuals, risk management policies, operational procedures, and internal controls."
                                },
                                {
                                    title: "4. License Application Submission",
                                    text: "Submit the full application package to the CRA, including corporate documents, compliance framework, and business plan."
                                },
                                {
                                    title: "5. Approval & Activation",
                                    text: "Once approved, the license is issued. Begin onboarding PSPs, banks, liquidity providers, and platform integrations."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "for offshore CRA brokerage licenses",
                                duration: "6–10 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Class A License",
                                description: "from USD 16,000",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Class B License",
                                description: "from USD 9,000",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Work with Offshore Advisory?'
                        items={
                            [
                                {
                                    title: "Licensed CRA-Agent Expertise",
                                    text: "We are officially authorized and experienced with CRA licensing procedures, ensuring smooth navigation through regulatory requirements."
                                },
                                {
                                    title: "End-to-End Brokerage Setup",
                                    text: "Full service including company formation, license application, compliance documentation, and MT4/MT5 platform integration."
                                },
                                {
                                    title: "Banking & PSP Introductions",
                                    text: "Access to reliable fiat and crypto payment processors, banking partners, and merchant service providers."
                                },
                                {
                                    title: "Liquidity Provider Access",
                                    text: "Direct connections to reputable forex and CFD liquidity providers for ECN, STP, and Market Maker models."
                                },
                                {
                                    title: "Transparent Pricing & Timelines",
                                    text: "Clear cost structure and predictable licensing schedules with no hidden fees."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                             Ready to start your brokerage?
                             "
                         description=
                             "
                                <b>Offshore Advisory</b> delivers <b>turnkey Forex & Brokerage License solutions</b> under <b>CRA</b> in <b>Western Sahara</b>.
                             "
                         buttonText='Book a Free Brokerage License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I operate worldwide with a CRA brokerage license?",
        content: [
            { type: "answer", text: "Yes — CRA licenses are designed for international activity (outside of SADR)." },
        ],
    },
    {
        question: "Do I need local presence?",
        content: [
            { type: "answer", text: "No physical office is required — remote setup is fully allowed." },
        ],
    },
    {
        question: "Can I integrate MT4/MT5 platforms with this license?",
        content: [
            { type: "answer", text: "Yes — MT4/MT5 white-label integrations are supported, and we assist with setup." },
        ],
    },
    {
        question: "Is crypto trading allowed?",
        content: [
            { type: "answer", text: "Yes — CRA supports forex + crypto hybrid brokerage models." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "There is *no capital requirement* for Western Sahara CRA brokerage licenses." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We launched our forex brokerage with a CRA license in under 2 months. Offshore Advisory handled everything from incorporation to MT5 integration.",
            author: "James L.",
            role: "FX Broker CEO"
        },
        {
            quote: "The CRA Class B license was perfect for our prop trading firm. The process was fast and cost-efficient.",
            author: "Maria K.",
            role: "Prop Firm Founder"
        }
    ]
;